const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMTV2MmgydjJoLTJ2MmgtMnYtMmgtMnYtMmgydi0yaDJ6bS4xODItMTJDMjIuMTg2IDMgMjMgMy44OTUgMjMgNXY4aC0ydi0zSDN2N2gxMXYySDIuODE4QzEuODE0IDE5IDEgMTguMTA1IDEgMTdWNWMwLTEuMTA1LjgxNC0yIDEuODE4LTJoMTguMzY0ek0yMSA1SDN2M2gxOFY1eiIgIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export {
  M as default
};
//# sourceMappingURL=card_add-907df50c.mjs.map
